/**
 * Build-time feature flags driven by `REACT_APP_*` env vars (distinct from the
 * runtime per-org feature-flag service). These gate in-development features at
 * the build level so they can ship dark to production.
 */

/**
 * Whether the Circuits feature is enabled for this build.
 *
 * Driven by `REACT_APP_ENABLE_CIRCUITS`, now enabled in every environment
 * including production. Gate any circuit data fetching / UI on this so the
 * feature can still be switched off per environment without a code change.
 */
export const circuitsEnabled = process.env.REACT_APP_ENABLE_CIRCUITS === "true";

export const markdownEnabled = process.env.REACT_APP_ENABLE_MARKDOWN_VIEW === "true";

/**
 * Whether the load velocity profile rework of the athlete profile profiling chart is enabled.
 * When off, the athlete profile renders `AthleteProfilingChartV1`, a copy of the chart before the rework.
 */
export const athleteProfilingV2Enabled = process.env.REACT_APP_ENABLE_ATHLETE_PROFILING_V2 === "true";

/**
 * Whether the new 1RM view in the athlete profile is enabled.
 * When off, the athlete profile renders the original 1RM view.
 */
export const athlete1RMV2Enabled = process.env.REACT_APP_ENABLE_ATHLETE_1RM_V2 === "true";

/**
 * Whether the new Workout review screen is enabled.
 * When on, the screen is registered at `/athlete-hub/:athleteId/completed-workouts/:completedWorkoutId`.
 * Nothing links to it yet, the completed workout entry points keep linking to the legacy page.
 */
export const workoutReviewV2Enabled = process.env.REACT_APP_ENABLE_WORKOUT_REVIEW_V2 === "true";

/**
 * Whether the velocity-based 1RM (`lvpAutomatedOneRepMax`) is offered as a metric on dashboard widgets.
 * When off, the dashboard 1RM metrics are the manual and Mayhew estimated 1RMs only.
 */
export const dashboardVelocityOneRepMaxEnabled = process.env.REACT_APP_ENABLE_DASHBOARD_VELOCITY_1RM === "true";
